export default "__VITE_ASSET__BqA4kwAk__"